"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * InodePilot documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.4.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableDataMetaToJSON = exports.TableDataMetaFromJSONTyped = exports.TableDataMetaFromJSON = exports.TableDataMetaTypesEnum = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
 * @export
 * @enum {string}
 */
var TableDataMetaTypesEnum;
(function (TableDataMetaTypesEnum) {
    TableDataMetaTypesEnum["STRING"] = "STRING";
    TableDataMetaTypesEnum["DOUBLE"] = "DOUBLE";
    TableDataMetaTypesEnum["INTEGER"] = "INTEGER";
    TableDataMetaTypesEnum["OBJECT"] = "OBJECT";
    TableDataMetaTypesEnum["TABLE"] = "TABLE";
    TableDataMetaTypesEnum["LIST"] = "LIST";
    TableDataMetaTypesEnum["EMPTY"] = "EMPTY";
    TableDataMetaTypesEnum["UNKNOWN"] = "UNKNOWN";
    TableDataMetaTypesEnum["NULL"] = "NULL";
    TableDataMetaTypesEnum["URL"] = "URL";
})(TableDataMetaTypesEnum = exports.TableDataMetaTypesEnum || (exports.TableDataMetaTypesEnum = {}));
function TableDataMetaFromJSON(json) {
    return TableDataMetaFromJSONTyped(json, false);
}
exports.TableDataMetaFromJSON = TableDataMetaFromJSON;
function TableDataMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        caption: !(0, runtime_1.exists)(json, "caption") ? undefined : json["caption"],
        classes: json["classes"],
        columns: json["columns"],
        dateformats: json["dateformats"],
        descriptors: !(0, runtime_1.exists)(json, "descriptors")
            ? undefined
            : json["descriptors"].map(_1.ColumnDescriptorFromJSON),
        labels: json["labels"],
        prefixSimilarityMatrix: json["prefixSimilarityMatrix"],
        redundancyMatrix: json["redundancyMatrix"],
        relation: json["relation"],
        relevancies: json["relevancies"],
        sourceQuery: !(0, runtime_1.exists)(json, "sourceQuery")
            ? undefined
            : json["sourceQuery"],
        types: json["types"],
    };
}
exports.TableDataMetaFromJSONTyped = TableDataMetaFromJSONTyped;
function TableDataMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        caption: value.caption,
        classes: value.classes,
        columns: value.columns,
        dateformats: value.dateformats,
        descriptors: value.descriptors === undefined
            ? undefined
            : value.descriptors.map(_1.ColumnDescriptorToJSON),
        labels: value.labels,
        prefixSimilarityMatrix: value.prefixSimilarityMatrix,
        redundancyMatrix: value.redundancyMatrix,
        relation: value.relation,
        relevancies: value.relevancies,
        sourceQuery: value.sourceQuery,
        types: value.types,
    };
}
exports.TableDataMetaToJSON = TableDataMetaToJSON;
